import { ThemeProvider } from '@mui/material/styles';
import { dashboardTheme } from './theme/dashboardTheme.js';

/**
 * Scopes the dashboard MUI theme to a page subtree. Nothing outside the
 * wrapped page is affected (no CssBaseline is rendered).
 */
export function DashboardThemeProvider({ children }) {
  return <ThemeProvider theme={dashboardTheme}>{children}</ThemeProvider>;
}

export default DashboardThemeProvider;
